import { render, staticRenderFns } from "./RoomTypeByBuildingReport.vue?vue&type=template&id=6ed0e961&"
import script from "./RoomTypeByBuildingReport.vue?vue&type=script&lang=js&"
export * from "./RoomTypeByBuildingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports